import useSWR from "swr"
import { ViewerData } from "./ViewerData"
import { callGetChapterRawData } from "../../api/novel/data/get"

type Params = {
  chapterId: number
}

export const useNovelViewer = ({ chapterId }: Params) => {
  const { data: viewerData, error } = useSWR<ViewerData>(
    `/api/novel/data?chapter_id=${chapterId}`,
    () => {
      return callGetChapterRawData(chapterId).then((v) => v.viewer)
    },
  )

  return {
    viewerData,
    error,
  }
}
